import React from 'react';
import { useRouter } from 'next/router';
import { getParameterByName, getModeByUrl } from "@util/config";
import { useSelector } from 'react-redux';
import { safeLocalStorage } from '@utils/localstorage';

const SuspiciousActivityModal = ({ suspiciousActivityData }) => {
    const router = useRouter();
    const drivingBot = safeLocalStorage.getItem('drivingBot')
    const torunamentId = getParameterByName('tournamentId') || getParameterByName('tournamentid') || ''
    const tournamentData = safeLocalStorage.getItem('tournamentData')
    const user = useSelector((state) => state?.setUserDetails?.user)

    const returnHomeHandler = () => {
        safeLocalStorage.removeItem(`selectControllerName`)
        safeLocalStorage.removeItem(`headlight`)
        safeLocalStorage.removeItem(`ride_sequence_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`rideId_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`ride_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`sessionId_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`bot_status_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`location_${drivingBot?.deviceId}`)
        safeLocalStorage.removeItem(`tournamentId_${torunamentId}`)
        safeLocalStorage.removeItem(`drivingBot`)
        safeLocalStorage.removeItem(`agoratoken_${tournamentData?.deviceId}`)
        safeLocalStorage.removeItem(`keyBinding_${user?.id}`)
        safeLocalStorage.removeItem(`tournamentData`)
        safeLocalStorage.removeItem(`keyboradKey`)
        safeLocalStorage.removeItem(`WheelKey`)
        safeLocalStorage.removeItem(`RemoteKey`)
        if (getModeByUrl() === 'playgame') {
            router.push("/testdrive");
        } else {
            router.push("/dashboard");
        }
    }

    return (
        <div className='flex w-[520px] p-[16px] flex-col gap-[16px] rounded-[32px] bg-[#F1F1F1] overflow-y-auto max-h-[405px] h-full'>
            <div className='flex px-[16px] py-[6px] justify-between items-center rounded-[16px] w-full'>
                <p className='text-[#000] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px] w-full'>Suspicious activity detected</p>
            </div>
            <div className='flex p-[16px] items-center gap-[16px] rounded-[16px] bg-[#FF1053]'>
                <div className='w-[32px] h-[32px]'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <mask id="mask0_7748_10377" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                            <rect width="32" height="32" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7748_10377)">
                            <path d="M15.9995 29.3681C15.6439 29.3681 15.305 29.3014 14.9828 29.1681C14.6606 29.0348 14.3661 28.8459 14.0995 28.6014L3.39948 17.9014C3.15503 17.6348 2.96615 17.3403 2.83281 17.0181C2.69948 16.6959 2.63281 16.357 2.63281 16.0014C2.63281 15.6459 2.69948 15.3014 2.83281 14.9681C2.96615 14.6348 3.15503 14.3459 3.39948 14.1014L14.0995 3.40143C14.3661 3.13477 14.6606 2.94032 14.9828 2.8181C15.305 2.69588 15.6439 2.63477 15.9995 2.63477C16.355 2.63477 16.6995 2.69588 17.0328 2.8181C17.3661 2.94032 17.655 3.13477 17.8995 3.40143L28.5995 14.1014C28.8661 14.3459 29.0606 14.6348 29.1828 14.9681C29.305 15.3014 29.3661 15.6459 29.3661 16.0014C29.3661 16.357 29.305 16.6959 29.1828 17.0181C29.0606 17.3403 28.8661 17.6348 28.5995 17.9014L17.8995 28.6014C17.655 28.8459 17.3661 29.0348 17.0328 29.1681C16.6995 29.3014 16.355 29.3681 15.9995 29.3681ZM15.9995 26.7014L26.6995 16.0014L15.9995 5.30143L5.29948 16.0014L15.9995 26.7014ZM14.6661 17.3348H17.3328V9.33477H14.6661V17.3348ZM15.9995 21.3348C16.3773 21.3348 16.6939 21.207 16.9495 20.9514C17.205 20.6959 17.3328 20.3792 17.3328 20.0014C17.3328 19.6237 17.205 19.307 16.9495 19.0514C16.6939 18.7959 16.3773 18.6681 15.9995 18.6681C15.6217 18.6681 15.305 18.7959 15.0495 19.0514C14.7939 19.307 14.6661 19.6237 14.6661 20.0014C14.6661 20.3792 14.7939 20.6959 15.0495 20.9514C15.305 21.207 15.6217 21.3348 15.9995 21.3348Z" fill="#FAFAFA" />
                        </g>
                    </svg>
                </div>
                <div className='flex items-center gap-[8px]'>
                    <p className='text-[#FAFAFA] text-[16px] not-italic font-medium leading-[20px] tracking-[-0.64px]'>You can review the reason for termination in 5-10 minutes in the home menu.</p>
                </div>
            </div>
            <div className='flex p-[16px] flex-col items-center gap-[32px] rounded-[16px] bg-[#FFF]'>
                <p className='text-[#737373] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>Your drive has been terminated due to suspicious activity found by the administration team. Please click below to return back home, a reason can be provided in the next 5-10 minutes. If you have any issues, please contact support.</p>
            </div>
            <div className='flex p-[16px] flex-col items-start gap-[16px] rounded-[16px] bg-[#FFF] w-full'>
                <button className='flex h-[56px] px-[16px] py-[12px] justify-center items-center gap-[10px] rounded-[39px] bg-[#000] w-full' onClick={returnHomeHandler}>
                    <p className='text-[#FAFAFA] text-[20px] not-italic font-semibold leading-[20px] tracking-[-0.8px]'>I understand, return to home</p>
                </button>
            </div>
        </div>
    )
}

export default SuspiciousActivityModal;